export interface CompanyFilters {
  name: string
  withVotes: boolean
}

export const getInitialCompanyFilters = (): CompanyFilters => ({
  name: '',
  withVotes: false,
})
